<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>CHAINE D'APPROBATION</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <p class="mt-5" >Nom <b style="color: #ff6141">*</b> </p>
                <vs-input
                    :danger="error_found.name ? true : false"
                    :danger-text="error_found.name ? error_found.name[0] : ''"
                    :disabled="detail__detail" v-model="input.name" class="w-full" name="item-code" />
                <div class="mt-5 w-full">
                    <span class="vs-select--label mr-2">Approbateurs <b style="color: #ff6141">*</b></span> <br>

                    <vs-list>
                      <draggable :list="selectedUsers" class="cursor-move">
                        <transition-group>
                          <vs-list-item class="list-item" v-for="listItem in selectedUsers" :key="listItem.id" :title="(listItem.profile ? '[' +listItem.profile + '] ' : '') +listItem.name">
                            <vs-avatar slot="avatar" :text="listItem.profile + ' ' +listItem.name" :src="listItem.photo" />
                            <span v-if="!detail__detail" style="cursor: pointer !important;" @click.prevent="removeManagerInList(listItem)">x</span>
                          </vs-list-item>
                        </transition-group>
                      </draggable>
                    </vs-list>

                    <div v-if="!detail__detail" class="text-right">
                        <vs-button type="border" size="small" @click="popupActive = true">Ajouter</vs-button>
                    </div>
                    <span v-if="!selectedUsers.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                         Le(s) approbateur(s) est(sont) réquis.
                    </span>
                </div>
                <vs-textarea :disabled="detail__detail" label="Notes" v-model="input.comment" class="mt-5 w-full" />

            </div>
            <vs-popup class="holamundo" title="Choisir des utilisateurs" :active.sync="popupActive">
                <form action="">
                    <v-select class="w-full" multiple label="name" v-model="selectedUsers" :options="users"></v-select>
                    <div class="mt-5">
                        <vs-button @click.prevent="addUsers">Ajouter</vs-button>
                    </div>
                    <div style="min-height: 50px !important;">
                    </div>
                </form>
            </vs-popup>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
        id: null,
        name: '',
        comment: '',
        node: []
    };

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import draggable from 'vuedraggable';
    export default {
        /* components: {VuePerfectScrollbar}, */
        components: {VuePerfectScrollbar, draggable},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                error: {
                    name: false
                },
                error_found: [],
                detail__detail: false,
                input: {},
                popupActive: false,
                selectedUsers: [],
                dataId: null,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
                users: []
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
            isFormValid() {
                var is_valide = true;
                if (!this.input.name || this.input.name === '') is_valide = false;
                if (!this.selectedUsers.length) is_valide = false;
                return is_valide;
            }
        },
        methods: {
            removeManagerInList(manager){
              let index = base_self.selectedUsers.indexOf(manager)
              base_self.selectedUsers.splice(index, 1)
            },
            async submitData() {
                var input = JSON.parse(JSON.stringify(this.input));
                let node = [];

                let length = base_self.selectedUsers.length;
                for (let iuoy = 0; iuoy < length; iuoy++) {
                    var item = base_self.selectedUsers[iuoy];
                    node.push(item.id);
                }
                delete input.node;
                input.node = node;
                if(!input.id) {
                    base_self.$vs.loading()
                    base_self.$http.post('/chains/create', input).then((response) =>{
                      if (response.data.status) {
                        base_self.$vs.loading.close()
                        window.GETCCMT.success('La chaîne d\'approbation est crée avec succès.', response);
                        window.ApprobationsApp.getChains();
                        this.$emit('closeSidebar');
                        this.initValues()
                      } else {
                        base_self.$vs.loading.close()
                        window.GETCCMT.error({ message: 'La création de la chaîne d\'approbation a échouée.' });
                      }
                    }).catch((error) => {
                      base_self.$vs.loading.close()
                      if (error.response.status === 401){
                        base_self.$router.push('/login')
                      }else {
                        base_self.error_found = error.response.data.errors
                      }
                    });
                } else if (input.id) {
                    base_self.$vs.loading()
                    base_self.$http.post('/chains/update', input).then((response) =>{
                      if (response.data.status) {
                        base_self.$vs.loading.close()
                        window.GETCCMT.success('La chaîne d\'approbation est modifiée avec succès.', response);
                        window.ApprobationsApp.getChains();
                        this.$emit('closeSidebar');
                        this.initValues()
                      } else {
                        base_self.$vs.loading.close()
                        window.GETCCMT.error({ message: 'La modification de la chaîne d\'approbation a échouée.' });
                      }
                    }).catch((error) => {
                      base_self.$vs.loading.close()
                      if (error.response.status === 401){
                        base_self.$router.push('/login')
                      }else {
                        base_self.error_found = error.response.data.errors
                      }
                    });
                }
            },
            initValues() {
                this.input = JSON.parse(JSON.stringify(input_tempon));
                this.selectedUsers = [];
                this.error_found = []
                this.detail__detail = false;
                window.ApprobationsApp.sidebarData.detail__detail = false;
                window.ApprobationsApp.sidebarData = {};
            },
            addUsers() {
                this.input.node = JSON.parse(JSON.stringify(this.selectedUsers));
                this.input = JSON.parse(JSON.stringify(this.input));
                this.popupActive = false;
            },
            async getUsers () {
                let response = await base_self.$store.state.users({}, { profile: 2  });
                base_self.last_page = response.data.last_page;
                base_self.users = response.data;
            },
        },
        created() {
            window.EditApprobation = this;
            base_self = this;
            base_self.initValues()
            base_self.getUsers()
        },
        watch: {
            async isSidebarActive() {
                this.input.comment = '';
                this.input.name = '';
                this.input.node = [];
                if (window.ApprobationsApp.sidebarData.id) {
                    base_self.$vs.loading()
                    let response = await base_self.$store.state.chains_detail({}, window.ApprobationsApp.sidebarData.id);
                    let length = response.data.nodes.length;
                    for (let iuoy = 0; iuoy < length; iuoy++) {
                        response.data.nodes[iuoy].id = response.data.nodes[iuoy].user_id;
                    }
                    this.input = JSON.parse(JSON.stringify(response.data));
                    this.input.node = JSON.parse(JSON.stringify(this.input.nodes));
                    this.selectedUsers = JSON.parse(JSON.stringify(this.input.nodes));
                    delete this.input.nodes;
                    this.detail__detail = window.ApprobationsApp.detail__detail;
                    base_self.$vs.loading.close()
                } else {
                    this.initValues();
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
</style>
